import React from "react";
import Nav from "./Navbar";
import {Link, useLocation} from "react-router-dom";
import CartLength from "../cart/CartLength";
import {useAuth} from "../../context/AuthContext"; // kendi yoluna göre düzelt
import {useNavigate} from "react-router-dom";


export default function Header({
                                   parentClass = "header-default",
                                   fullWidth = false,
                               }) {
    const {pathname} = useLocation();
    const navigate = useNavigate();

    const { isAuthenticated, logout, openLoginModal } = useAuth();

    const triggerLogin = () => {
        // localStorage.setItem("logoutMessage", "Season Expired. Please login again!");
        openLoginModal();
    };

    const handleLogout = () => {
        logout(); // auth context içindeki logout'u çalıştır
        navigate("/"); // anasayfaya yönlendir
    };


    return (
        <header id="header" className={parentClass}>
            <div className={fullWidth ? "container-full" : "container"}>
                <div className="row wrapper-header align-items-center">
                    <div className="col-md-4 col-3 d-xl-none">
                        <a
                            href="#mobileMenu"
                            className="mobile-menu"
                            data-bs-toggle="offcanvas"
                            aria-controls="mobileMenu"
                        >
                            <i className="icon icon-categories1"/>
                        </a>
                    </div>
                    <div className="col-xl-2 col-md-4 col-6">
                        <Link to={`/`} className="logo-header">
                            <img
                                alt="logo"
                                className="logo"
                                src="/images/logo/logo.svg"
                                width={148}
                                height={44}
                            />
                        </Link>
                    </div>
                    <div className="col-xl-8 d-none d-xl-block">
                        <nav className="box-navigation text-center">
                            <ul className="box-nav-menu">
                                <Nav/>
                            </ul>
                        </nav>
                    </div>
                    <div className="col-xl-2 col-md-4 col-3">
                        <ul className="nav-icon d-flex justify-content-end align-items-center">
                            <li className="nav-search">
                                <a
                                    href="#search"
                                    data-bs-toggle="offcanvas"
                                    className="nav-icon-item"
                                >
                                    <i className="icon icon-search"/>
                                </a>
                            </li>
                            {/*<li className="nav-account">*/}
                            {/*    {isAuthenticated ? (*/}
                            {/*        // GİRİŞ YAPMIŞSA - account sayfasına yönlendir*/}
                            {/*        <Link to="/account-page" className="nav-icon-item">*/}
                            {/*            <i className="icon icon-user"/>*/}
                            {/*        </Link>*/}
                            {/*    ) : (*/}
                            {/*        // GİRİŞ YAPMAMIŞSA - login modali aç*/}
                            {/*        <a*/}
                            {/*            href="#login"*/}
                            {/*            data-bs-toggle="offcanvas"*/}
                            {/*            aria-controls="login"*/}
                            {/*            className="nav-icon-item"*/}
                            {/*        >*/}
                            {/*            <i className="icon icon-user"/>*/}
                            {/*        </a>*/}
                            {/*    )}*/}
                            {/*</li>*/}
                            {/*{isAuthenticated && (*/}
                            {/*    <li className="nav-search">*/}


                            {/*        <button*/}
                            {/*            onClick={handleLogout}*/}
                            {/*            className="nav-icon-item btn btn-link p-0 border-0"*/}
                            {/*            style={{color: "inherit", textDecoration: "none"}}*/}
                            {/*        >*/}
                            {/*            <img*/}
                            {/*                src="https://img.icons8.com/?size=100&id=16570&format=png&color=000000"*/}
                            {/*                alt="Logout"*/}
                            {/*                width={20}*/}
                            {/*                height={20}*/}
                            {/*            />*/}
                            {/*        </button>*/}


                            {/*    </li>*/}
                            {/*)}*/}
                            {/*

                            */}


                            <li className="nav-account">
                                {isAuthenticated ? (
                                    <Link to="/account-page" className="nav-icon-item">
                                        <i className="icon icon-user" />
                                    </Link>
                                ) : (
                                    <button
                                        onClick={triggerLogin}
                                        className="nav-icon-item btn p-0 border-0 bg-transparent"
                                    >
                                        <i className="icon icon-user" />
                                    </button>
                                )}
                            </li>

                            {isAuthenticated && (
                                <li className="nav-search">
                                    <button
                                        onClick={handleLogout}
                                        className="nav-icon-item btn btn-link p-0 border-0"
                                        style={{color: "inherit", textDecoration: "none"}}
                                    >
                                        <img
                                            src="https://img.icons8.com/?size=100&id=16570&format=png&color=000000"
                                            alt="Logout"
                                            width={20}
                                            height={20}
                                        />
                                    </button>
                                </li>
                            )}
                            <li className="nav-cart">
                                <a
                                    href="#shoppingCart"
                                    data-bs-toggle={`${
                                        pathname == "/cart-drawer-v2" ? "modal" : "offcanvas"
                                    }`}
                                    className="nav-icon-item"
                                >
                                    <i className="icon icon-cart"/>
                                    <span className="count-box">
                                    <CartLength/>
                                  </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
}
